module.exports = __webpack_public_path__ + "static/media/sidebar__pway.2a0b57b2.svg";